import { EntityManagerFieldInfos } from '@record-it-npm/synchro-client';
import { createWorkTimeEntryEntityInfo } from 'record-it-time-common/entity/entities/WorkTimeEntry/createWorkTimeEntryEntityInfo';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';
import { WorkTimeEntry } from './workTimeEntryTypes';
export const workTimeEntryEntityInfo = createWorkTimeEntryEntityInfo<WorkTimeEntry>({
  additionalFieldInfos: EntityManagerFieldInfos.createAdditionalFieldInfos<AppSynchronizationEnvironmentTypes>()
});